export const heightWithToolbar = "calc(calc(var(--vh, 1vh) * 100) - 98px)";
const sourceLocal420 = 420;

export function compatibleSources(
  ASourceID: number,
  BSourceID: number,
  strict?: boolean
): boolean {
  if (ASourceID == sourceLocal420 && BSourceID == sourceLocal420) {
    return true;
  }

  if (strict ?? false) {
    return ASourceID == BSourceID;
  }

  return ASourceID != sourceLocal420 && BSourceID != sourceLocal420;
}
